import { createAsyncActionTypes } from '../../util/createActionTypes';

export default createAsyncActionTypes(['FETCH_EVALUATED_POLICY']);
